import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './router'
import App from './App'
import i18n from './lang' // Internationalization

//全局样式重置
import './style/reset.scss'
import 'swiper/dist/css/swiper.css';

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import Toast from './components/toast'
Vue.use(Toast)

import './config/rem'
//register global componments
import './config/reg.js'
import * as filters from './config/filter.js' // global filters
// register global utility filters.
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
import { Notify, Form, Field, Button, Picker, Popup, Uploader, Dialog  } from 'vant';
Vue.use(Form)
Vue.use(Field)
Vue.use(Button)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Uploader)
Vue.use(Dialog)

Notify.setDefaultOptions({
    background:"#fdf6ec",
    color:"#e6a23c",
    duration:1000
})
import {
    routerMode,
    imgBaseUrl,
    baseUrl
} from './config/url'

import {
    toThumbsimg //缩略图
} from './config/toThumbsimg'

import * as utils from './config/utils'

import api from './service' //接口

Vue.prototype.$baseUrl = baseUrl;
Vue.prototype.$imgBaseUrl = imgBaseUrl;
Vue.prototype.$toThumbsimg = toThumbsimg;
Vue.prototype.$utils = utils;
Vue.prototype.$api = api;
Vue.use(VueRouter)

import 'vant/lib/index.css';

const router = new VueRouter({
        routes,
        mode: routerMode,
        base: '/m/',
        strict: process.env.NODE_ENV !== 'production',
        scrollBehavior(to, from, savedPosition) {
            if (savedPosition) {
                return savedPosition
            } else {
                if (from.meta.keepAlive) {
                    from.meta.savedPosition = document.body.scrollTop;
                }
                return {
                    x: 0,
                    y: to.meta.savedPosition || 0
                }
            }
        }
    })
    router.beforeEach((to,from,next)=>{
    
        if(to.query.is=='3'){
            Notify("正在建设中");
        }else{
            next();
        }
    })
    // router.beforeEach((to, from, next) => {
    //     var lang = utils.getStore("lang") || 'zh';
    //     let newPath = to.path.index + '/' + lang;
    //     console.log(newPath)
    //         // next({
    //         //     path: newPath
    //         // });
    //         // if (!store.state.userInfo && to.path != '/login') {
    //         //     next({ path: '/login' });
    //         // } else {
    //         //     next();
    //         // }
    // });
    /**
     * Next, we will create a fresh Vue application instance and attach it to
     * the page. Then, you may begin adding components to this application
     * or customize the JavaScript scaffolding to fit your unique needs.
     */
Vue.config.productionTip = false

const app = new Vue({
    el: '#app',
    components: {
        App
    },
    i18n,
    router,
});